export const Types = {
  SET_RECORD: 'SET_RECORD',
  SAVE_LIST_NEWS : 'SAVE_LIST_NEWS',
}
